import { useEffect, type ReactElement, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'
import { useOnboardingStore } from '@/stores/onboarding.store'

export function RequireOnboarding({ children }: { children: ReactNode }): ReactElement {
  const { user } = useAuth()
  const userIdKey = user?.id ?? '__anonymous__'

  const expiryTimestamp = useOnboardingStore((state) => state.seenBy[userIdKey])
  const markSeen = useOnboardingStore((state) => state.markSeen)

  const seen = !!expiryTimestamp && Date.now() <= expiryTimestamp

  useEffect(() => {
    if (seen) {
      markSeen(user?.id ?? null)
    }
  }, [seen, markSeen, user?.id])

  const isStudent = user?.roles.includes('Student')

  if (!seen && !isStudent) return <Navigate to="/decision" replace />

  return <>{children}</>
}
